import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarcab() {



const cardData =
{
  keyword: 'Pune to Mahabaleshwar Cabs',
  heading: 'Lotus Cab: Pune to Mahabaleshwar Cabs',
  headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Mahabaleshwar Cabs for family vacations, weekend getaways, honeymoon trips, corporate outings, sightseeing tours, and one-way or round-trip travel. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe travel through the scenic Western Ghats, Lotus Cabs ensures a comfortable, enjoyable, and hassle-free journey to Mahabaleshwar.",


  top: 'Top Places to Visit in Mahabaleshwar with Lotus Cab',

topPlaces: [
    {
        title: "Venna Lake",
        description:
            "Venna Lake is one of Mahabaleshwar's most popular tourist attractions, offering boating, horse riding, lakeside food stalls, and beautiful natural surroundings. Families, couples, and groups visiting from Pune enjoy spending quality time by the lake while experiencing the cool climate and peaceful atmosphere that make Mahabaleshwar a favorite hill station."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a must-visit destination famous for fresh strawberries, delicious fruit products, chocolates, sandwiches, and scenic garden surroundings. Visitors traveling from Pune frequently stop here to enjoy local delicacies, shop for authentic products, and relax in one of Mahabaleshwar's most iconic attractions."
    },
    {
        title: "Arthur's Seat",
        description:
            "Arthur's Seat is one of the most spectacular viewpoints in Mahabaleshwar, offering breathtaking panoramic views of deep valleys, lush forests, and the Savitri River below. It is a favorite destination for photographers, nature lovers, and tourists seeking unforgettable scenic experiences in the Sahyadri mountain range."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest point in Mahabaleshwar and is renowned for its magnificent sunrise views and cool mountain breeze. Travelers from Pune often visit early in the morning to witness spectacular views of the surrounding hills, making it one of the most memorable sightseeing spots in the region."
    },
    {
        title: "Elephant's Head Point",
        description:
            "Elephant's Head Point is a unique natural rock formation resembling an elephant's head and trunk. The viewpoint offers mesmerizing valley views, dramatic cliffs, and excellent photography opportunities, making it one of the most visited attractions for tourists exploring Mahabaleshwar."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is a beautiful natural attraction surrounded by dense greenery and picturesque landscapes. During the monsoon season, the waterfall becomes especially spectacular, attracting families, couples, and nature enthusiasts looking to enjoy Mahabaleshwar's refreshing climate and scenic beauty."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is a historic Maratha fort built by Chhatrapati Shivaji Maharaj and is one of the most significant historical landmarks near Mahabaleshwar. Visitors enjoy exploring its impressive architecture, historical monuments, temples, and panoramic views while learning about Maharashtra's glorious heritage."
    },
    {
        title: "Kate's Point",
        description:
            "Kate's Point is a famous viewpoint offering stunning vistas of the Dhom Dam, Krishna Valley, and surrounding mountain ranges. Its peaceful atmosphere and spectacular scenery make it a favorite stop for sightseeing, photography, and enjoying the natural beauty of Mahabaleshwar."
    },
    {
        title: "Panchgani",
        description:
            "Panchgani is a charming hill station located just a short drive from Mahabaleshwar and is famous for Table Land, Sydney Point, Parsi Point, strawberry farms, and colonial-era charm. Many travelers from Pune include Panchgani in their itinerary for a complete and memorable hill station experience."
    },
    {
        title: "Mahabaleshwar Temple",
        description:
            "Mahabaleshwar Temple is an ancient temple dedicated to Lord Shiva and is one of the region's most sacred religious sites. Known for its beautiful Hemadpanti architecture and spiritual significance, the temple attracts thousands of devotees and tourists seeking blessings while exploring the cultural heritage of Mahabaleshwar."
    }
],

  "services": [
    {
      "name": "Pune to Mahabaleshwar Cabs",
      "description": "Book Pune to Mahabaleshwar Cabs with Lotus Cab for safe and scenic hill-station travel. Our experienced drivers are trained for mountain driving and ensure smooth navigation through winding ghat roads. We provide clean AC sedans and spacious SUVs suitable for couples, families, and groups. Transparent pricing, punctual pickup, and 24/7 support make your journey stress-free. Whether for weekend relaxation or extended vacation, our service guarantees comfort and reliability."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi Service",
      "description": "Our Pune to Mahabaleshwar Taxi Service offers reliable long-distance travel with professional drivers and comfortable vehicles. Ideal for weekend trips, business retreats, or family holidays."
    },
    {
      "name": "Pune to Mahabaleshwar One Way Cab",
      "description": "Affordable one-way cab option allowing travelers to pay only for the drop journey without return charges."
    },
    {
      "name": "Pune to Mahabaleshwar Round Trip Taxi",
      "description": "Flexible round-trip cab service with customizable return timing for convenience."
    },
    {
      "name": "Pune to Mahabaleshwar Tour Cab",
      "description": "Complete tour cab service covering major sightseeing points with experienced local drivers."
    },
    {
      "name": "Affordable Pune to Mahabaleshwar Cab",
      "description": "Budget-friendly pricing with transparent billing and reliable vehicles."
    },
    {
      "name": "Luxury Cab Pune to Mahabaleshwar",
      "description": "Premium sedan and SUV vehicles offering superior comfort and executive travel experience."
    },
    {
      "name": "SUV Taxi Pune to Mahabaleshwar",
      "description": "Spacious SUV option ideal for family and group travel with extra luggage."
    },
    {
      "name": "Best Cab Service Pune to Mahabaleshwar",
      "description": "Top-rated cab service known for punctuality, safety, and customer satisfaction."
    }
  ],

  "tableData": [
    ["Pune to Mahabaleshwar Cabs", "Pune to Mahabaleshwar Taxi Service"],
    ["Pune to Mahabaleshwar One Way Cab", "Pune to Mahabaleshwar Round Trip Taxi"],
    ["Pune to Mahabaleshwar Tour Cab", "Affordable Pune to Mahabaleshwar Cab"],
    ["Luxury Cab Pune to Mahabaleshwar", "SUV Taxi Pune to Mahabaleshwar"],
    ["Cheap Pune to Mahabaleshwar Taxi", "Online Cab Booking Pune to Mahabaleshwar"],
    ["Best Cab Service Pune to Mahabaleshwar", "Pune to Mahabaleshwar Weekend Trip Cab"],
    ["Family Trip Cab Pune Mahabaleshwar", ""]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Hill Drivers", "WhyChoosedescription": "Our drivers are trained for safe mountain and ghat road travel." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "No hidden charges with clear fare structure." },
    { "WhyChooseheading": "Comfortable Vehicles", "WhyChoosedescription": "AC sedans and SUVs for comfortable long-distance travel." },
    { "WhyChooseheading": "Flexible Travel Options", "WhyChoosedescription": "One-way and round-trip packages available." },
    { "WhyChooseheading": "24/7 Support", "WhyChoosedescription": "Round-the-clock assistance and booking support." },
    { "WhyChooseheading": "Perfect for Weekend Trips", "WhyChoosedescription": "Convenient cab solutions for short vacations." },
    { "WhyChooseheading": "Family-Friendly Service", "WhyChoosedescription": "Spacious vehicles ideal for family trips." },
    { "WhyChooseheading": "Safe Night Travel", "WhyChoosedescription": "Secure and verified drivers for late-night departures." }
  ]
}

const faqData = [
  { question: 'Do you provide one-way cab from Pune to Mahabaleshwar?', answer: 'Yes, one-way and round-trip services are available.' },
  { question: 'Is hill driving safe?', answer: 'Yes, drivers are experienced in mountain routes.' },
  { question: 'Are SUVs available?', answer: 'Yes, SUV and sedan options available.' },
  { question: 'Is pricing transparent?', answer: 'Yes, no hidden charges.' },
  { question: 'Is weekend booking available?', answer: 'Yes, weekend and holiday bookings available.' },
  { question: 'Do you provide tour packages?', answer: 'Yes, full sightseeing cab packages available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, especially during peak season.' },
  { question: 'Are vehicles AC?', answer: 'Yes, fully air-conditioned vehicles.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are verified and trained.' },
  { question: 'Do you offer corporate travel?', answer: 'Yes, corporate and executive cab services available.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Rohit Patil', feedback: 'Wonderful weekend trip to Mahabaleshwar. Driver handled ghat roads smoothly and car was very comfortable.', rating: 5 },
  { id: 2, name: 'Mrs. Kavya Deshmukh', feedback: 'Booked family cab for Mahabaleshwar tour. Transparent pricing and professional service.', rating: 5 }
];











































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mahabaleshwar Cabs",
"image": "https://lotuscab.com/assets/images/pune-to-mahabaleshwar-cabs.jpg",
"description": "Book Pune to Mahabaleshwar Cabs with Lotus Cab for affordable, safe, and comfortable travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6018"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-mahabaleshwar-cabs"
}
};






  return (
    <div>
      

<Helmet>
  <title>Pune to Mahabaleshwar Cabs | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Mahabaleshwar Cabs with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Mahabaleshwar Cabs, Pune to Mahabaleshwar Cab, Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar Taxi Service, Mahabaleshwar Cab from Pune, One Way Cab Pune to Mahabaleshwar, Round Trip Cab Pune to Mahabaleshwar, Outstation Cab Pune to Mahabaleshwar, Pune to Mahabaleshwar Car Rental, Affordable Pune to Mahabaleshwar Cab, Cheap Pune to Mahabaleshwar Taxi, Online Pune to Mahabaleshwar Cab Booking, Sedan Cab Pune to Mahabaleshwar, SUV Cab Pune to Mahabaleshwar, Best Pune to Mahabaleshwar Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarcab;